import React from "react";
import { Box } from "@mui/system";
import { useSelector } from "react-redux";
import { Typography } from "@mui/material";
import useSWR from "swr";

import LoginHeader from "../LoginHeader";
import CustomAvatar from "../../CustomAvatar";
import { getPlayerState } from "../../../../redux/features/playerSlice";
import UseWindowDimensions from "./../../../../utils/windowSize";
import { getSettingState } from "../../../../redux/features/settingSlice";
import CustomSelectAvatar from "../../CustomSelectAvatar";
import CustomHelmet from "../../CustomHelmet";

const EditAvatarPage = () => {
  const { height } = UseWindowDimensions();
  const { minimizePlayer } = useSelector(getPlayerState);
  const { userData, localAvatar } = useSelector(getSettingState);

  const { data: profile } = useSWR(() => {
    if (!userData) {
      return null;
    }
    return `${process.env.REACT_APP_API}/auth/profile/${userData}/`;
  });

  return (
    <>
      <CustomHelmet title={`Edit avatar | Azad`} />

      <Box sx={{ height: "100%", backgroundColor: "white.main" }}>
        <LoginHeader type='editAvatar' />
        <Box
          sx={{
            display: "flex",
            height: height + "px",
            alignItems: "end",
          }}
        >
          <Box sx={{ width: "100%", mb: "72px", mt: "96px" }}>
            <Box sx={{ px: "16px", mb: "12px" }}>
              <Typography
                sx={{
                  fontSize: "40px",
                  fontWeight: 700,
                  fontFamily: "Tahrir",
                  lineHeight: "40px",
                }}
              >
                Welcome To Azad
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                border: "2px solid",
                borderBottom: "3px solid",
                borderColor: "black.main",
                padding: "24px 16px 0 16px",
                borderRadius: "16px 16px 0 0",
              }}
            >
              <Box sx={{ display: "inline-flex", mb: "10px" }}>
                <CustomAvatar
                  size={64}
                  src={localAvatar ? localAvatar : profile?.avatar}
                />
              </Box>

              <Typography
                sx={{ fontSize: "20px", lineHeight: "28px", mb: "20px" }}
              >
                This is your Profile picture, you can change it as you wish.
              </Typography>

              <Box
                sx={{
                  height: height + -407 - (minimizePlayer ? 82 : 0) + "px",
                  overflowY: "auto",
                }}
              >
                <CustomSelectAvatar footer />
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default EditAvatarPage;
